import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

export interface DocumentCreationPayload {
  templateDocumentId?: number;
  projectId?: number;
  contractId?: number;
  projectTaskId?: number;
  /** Site context for callers with no project — the site-scoped Grundstücke page. */
  gridConnectionId?: number;
  /** Serienbrief: scopes property_* to one land owner and fills the property_owner_* fields. */
  propertyOwnerId?: number;
  /** Skips the server-side PDF render; the client re-fills the one document it previews. */
  skipPreview?: boolean;
}

/** Automatic document creation (epic #148). All endpoints are feature-flag gated server-side. */
@Injectable({
  providedIn: 'root',
})
export class DocumentCreationService {
  constructor(private apiService: ApiBaseService) {}

  /** Scans the template for {{token}} fields and reports what can be filled (#1210). */
  async validateTemplate(payload: DocumentCreationPayload, ownFile: File | null = null): Promise<any> {
    return this.post('DocumentCreationService/ValidateTemplate', payload, ownFile);
  }

  /** Fills the template with system data; returns the filled document bytes, a PDF preview and the default name (#1212). */
  async fillTemplate(payload: DocumentCreationPayload, ownFile: File | null = null): Promise<any> {
    return this.post('DocumentCreationService/FillTemplate', payload, ownFile);
  }

  private post(apiPath: string, payload: DocumentCreationPayload, ownFile: File | null): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
      if (value != null) formData.append(key, `${value}`);
    }
    if (ownFile != null) {
      formData.append('Filename', ownFile.name);
      formData.append('FileBytes', ownFile, ownFile.name);
    }
    // showLoader: false — fill-template-modal already shows its own progress UI ('validating'
    // step) for these calls; the global dx-load-panel would otherwise overlay it as a second one.
    return this.apiService.httpRequestForm(apiPath, formData, true, false);
  }
}
